/**
 * WebSocket 消息协议处理
 * 协议格式: [接收方ID(10)] + [发送类型(2)] + [文件类型(2)] + [扩展(2)] + [数据长度(10)] + [数据内容]
 */

class WSMessageProtocol {
  // 发送类型枚举
  static SEND_TYPE = {
    TO_USER: '00', // 发给用户
    TO_SHOP: '01' // 发给店铺
  }

  // 文件类型枚举
  static FILE_TYPE = {
    TEXT: '01', // 文本
    IMAGE: '02', // 图片
    AUDIO: '03', // 音频
    VIDEO: '04' // 视频
  }

  /**
   * 合成消息
   * @param {Object} options - 消息参数
   * @param {string} options.sendType - 发送类型 (00/01)
   * @param {string} options.fileType - 文件类型 (01/02/03/04)
   * @param {string} options.extend - 扩展位 (2位，默认'00')
   * @param {string|Buffer} options.data - 要发送的数据
   * @returns {string} 合成后的完整消息字符串
   */
  encode(receiverId, data, sendType, fileType, extend = "00") {
    // 1. 处理接收方ID (固定10位，左补0)
    const paddedReceiverId = receiverId;
    // 4. 处理扩展位 (固定2位)
    const paddedExtend = extend.toString().padStart(2, '0');
    /* console.log("需要传入的id", paddedReceiverId);
    if (paddedReceiverId.length !== 10) {
      throw new Error(`ReceiverId must be 10 digits, got ${paddedReceiverId.length}`);
    }

    // 2. 验证发送类型
    if (!Object.values(this.SEND_TYPE).includes(sendType)) {
      throw new Error(`Invalid sendType: ${sendType}. Must be '00' or '01'`);
    }

    // 3. 验证文件类型
    if (!Object.values(this.FILE_TYPE).includes(fileType)) {
      throw new Error(`Invalid fileType: ${fileType}. Must be '01', '02', '03', or '04'`);
    }
    if (paddedExtend.length !== 2) {
      throw new Error(`Extend must be 2 digits, got ${paddedExtend.length}`);
    }
*/
    // 5. 准备数据并计算长度
    let dataStr = '';
    let dataLength = 0;

    if (typeof data === 'string') {
      dataStr = data;
      dataLength = data.length;
    } else if (data instanceof Buffer) {
      dataStr = data.toString('utf-8');
      dataLength = data.length;
    } else if (typeof data === 'object') {
      dataStr = JSON.stringify(data);
      dataLength = dataStr.length;
    } else {
      dataStr = String(data);
      dataLength = dataStr.length;
    }

    // 6. 数据长度 (固定10位，左补0)
    const paddedDataLength = dataLength.toString().padStart(10, '0');
    if (paddedDataLength.length !== 10) {
      throw new Error(`Data length exceeds maximum (10 digits), got ${dataLength}`);
    }
    console.log(paddedReceiverId);

    console.log(sendType);
    console.log(fileType);
    console.log(paddedExtend);
    console.log(paddedDataLength);
    // 7. 拼接完整消息
    const message = paddedReceiverId + sendType + fileType + paddedExtend + paddedDataLength + dataStr;
    console.log("message-------------------------", message);
    return message;
  }

  /**
   * 解析消息
   * @param {string} message - 接收到的原始消息字符串
   * @returns {Object} 解析后的消息对象
   */
  decode(message) {
    if (!message || typeof message !== 'string') {
      throw new Error('Invalid message: message must be a non-empty string');
    }

    // 固定头部长度: 10(接收方) + 2(发送类型) + 2(文件类型) + 2(扩展) + 10(数据长度) = 26位
    const HEADER_LENGTH = 26;

    if (message.length < HEADER_LENGTH) {
      throw new Error(`Invalid message: too short (${message.length} < ${HEADER_LENGTH})`);
    }

    // 1. 解析头部
    const receiverId = message.substring(0, 10);
    const sendType = message.substring(10, 12);
    const fileType = message.substring(12, 14);
    const extend = message.substring(14, 16);
    const dataLength = parseInt(message.substring(16, 26), 10);

    // 2. 验证数据长度
    if (isNaN(dataLength)) {
      throw new Error('Invalid data length in message');
    }

    // 3. 提取数据内容
    const dataStart = HEADER_LENGTH;
    const dataEnd = dataStart + dataLength;

    if (message.length < dataEnd) {
      throw new Error(`Invalid message: data length mismatch (expected ${dataLength}, got ${message.length - HEADER_LENGTH})`);
    }

    let data = message.substring(dataStart, dataEnd);

    // 4. 根据文件类型解析数据
    let parsedData = data;
    switch (fileType) {
      case WSMessageProtocol.FILE_TYPE.TEXT:
        // 文本类型，保持原样
        parsedData = data;
        break;
      case WSMessageProtocol.FILE_TYPE.IMAGE:
      case WSMessageProtocol.FILE_TYPE.AUDIO:
      case WSMessageProtocol.FILE_TYPE.VIDEO:
        // 媒体类型，尝试解析为 JSON (可能包含 URL 或 base64)
        try {
          parsedData = JSON.parse(data);
        } catch (e) {
          // 如果不是 JSON，保持原样
          parsedData = data;
        }
        break;
      default:
        parsedData = data;
    }

    // 5. 返回解析结果
    return {
      receiverId: receiverId.replace(/^0+/, '') || '0', // 去除前导0
      rawReceiverId: receiverId,
      sendType: sendType,
      sendTypeName: WSMessageProtocol.getSendTypeName(sendType),
      fileType: fileType,
      fileTypeName: WSMessageProtocol.getFileTypeName(fileType),
      extend: extend,
      dataLength: dataLength,
      rawData: data,
      data: parsedData
    };
  }

  /**
   * 获取发送类型名称
   */
  static getSendTypeName(sendType) {
    const map = {
      '00': '发给用户',
      '01': '发给店铺'
    };
    return map[sendType] || '未知';
  }

  /**
   * 获取文件类型名称
   */
  static getFileTypeName(fileType) {
    const map = {
      '01': '文本',
      '02': '图片',
      '03': '音频',
      '04': '视频'
    };
    return map[fileType] || '未知';
  }

  /**
   * 便捷方法：发送文本消息给用户
   */
  encodeTextToUser(receiverId, text) {
    console.log("WSMessageProtocol.SEND_TYPE.TO_USER", WSMessageProtocol.SEND_TYPE.TO_USER);
    console.log("WSMessageProtocol.SEND_TYPE.TO_USER", WSMessageProtocol.FILE_TYPE.TEXT);
    return this.encode(
      receiverId,
      text,
      WSMessageProtocol.SEND_TYPE.TO_USER,
      WSMessageProtocol.FILE_TYPE.TEXT
    );
  }

  /**
   * 便捷方法：发送文本消息给店铺
   */
  static encodeTextToShop(receiverId, text) {
    return this.encode({
      receiverId: receiverId,
      sendType: WSMessageProtocol.SEND_TYPE.TO_SHOP,
      fileType: WSMessageProtocol.FILE_TYPE.TEXT,
      data: text
    });
  }

  /**
   * 便捷方法：发送图片消息
   */
  static encodeImage(receiverId, sendType, imageUrl) {
    return this.encode({
      receiverId: receiverId,
      sendType: sendType,
      fileType: this.FILE_TYPE.IMAGE,
      data: JSON.stringify({ url: imageUrl, type: 'image' })
    });
  }

  /**
   * 批量解析消息（用于接收多条消息）
   */
  static decodeBatch(messages) {
    return messages.map(msg => this.decode(msg));
  }

  /**
   * 验证消息格式是否正确
   */
  static isValid(message) {
    try {
      this.decode(message);
      return true;
    } catch (error) {
      return false;
    }
  }
}

// ============= 使用示例 =============

// 示例1: 发送文本消息给用户
/* const textMsg = WSMessageProtocol.encodeTextToUser('1234567890', '你好，这是一条测试消息');
console.log('文本消息:', textMsg);
console.log('解析结果:', WSMessageProtocol.decode(textMsg));
 */
// 示例2: 发送文本消息给店铺
/* const shopMsg = WSMessageProtocol.encodeTextToShop('9876543210', '店铺您好，有新的订单');
console.log('\n店铺消息:', shopMsg);
console.log('解析结果:', WSMessageProtocol.decode(shopMsg));
 */
// 示例3: 发送图片消息
/* const imageMsg = WSMessageProtocol.encodeImage('1234567890', WSMessageProtocol.SEND_TYPE.TO_USER, 'https://example.com/image.jpg');
console.log('\n图片消息:', imageMsg);
console.log('解析结果:', WSMessageProtocol.decode(imageMsg));
 */
// 示例4: 自定义消息
/* const customMsg = WSMessageProtocol.encode({
  receiverId: '999',
  sendType: WSMessageProtocol.SEND_TYPE.TO_USER,
  fileType: WSMessageProtocol.FILE_TYPE.TEXT,
  extend: '01', // 自定义扩展位
  data: JSON.stringify({
    action: 'custom',
    content: '自定义消息'
  })
});
console.log('\n自定义消息:', customMsg);
console.log('解析结果:', WSMessageProtocol.decode(customMsg));
 */
/* eslint-disable */
// 示例5: 在 WebSocket 中的使用
class ChatWebSocket {
  constructor(url) {
    this.url = url;
    this.socket = null;
  }

  connect() {
    this.socket = new WebSocket(this.url);

    this.socket.onmessage = (event) => {
      try {
        // 解析接收到的消息
        const parsedMsg = WSMessageProtocol.decode(event.data);
        console.log('收到消息:', parsedMsg);

        // 根据文件类型处理
        switch (parsedMsg.fileType) {
          case WSMessageProtocol.FILE_TYPE.TEXT:
            this.onTextMessage(parsedMsg);
            break;
          case WSMessageProtocol.FILE_TYPE.IMAGE:
            this.onImageMessage(parsedMsg);
            break;
          case WSMessageProtocol.FILE_TYPE.AUDIO:
            this.onAudioMessage(parsedMsg);
            break;
          case WSMessageProtocol.FILE_TYPE.VIDEO:
            this.onVideoMessage(parsedMsg);
            break;
        }
      } catch (error) {
        console.error('解析消息失败:', error);
      }
    };
  }

  sendTextToUser(receiverId, text) {
    const message = WSMessageProtocol.encodeTextToUser(receiverId, text);
    this.socket.send(message);
  }

  sendTextToShop(receiverId, text) {
    const message = WSMessageProtocol.encodeTextToShop(receiverId, text);
    this.socket.send(message);
  }

  onTextMessage(msg) {
    console.log(`[文本消息] 来自: ${msg.receiverId}, 内容: ${msg.data}`);
  }

  onImageMessage(msg) {
    console.log(`[图片消息] 来自: ${msg.receiverId}, URL: ${msg.data.url}`);
  }

  onAudioMessage(msg) {
    console.log(`[音频消息] 来自: ${msg.receiverId}, 数据: ${msg.data}`);
  }

  onVideoMessage(msg) {
    console.log(`[视频消息] 来自: ${msg.receiverId}, 数据: ${msg.data}`);
  }
}

// 导出模块
if (typeof module !== 'undefined' && module.exports) {
  module.exports = WSMessageProtocol;
}